import { Component } from 'react'
import { connect } from 'react-redux'

import './index.scss'

import { APPCONFIG } from '../../configs/app'

// import IconBenan from '../../asserts/icon/beian.png'

class AppFooter extends Component {

  static defaultProps = {}

  state = {}

  render () {
    let { lang } = this.props
    let { contact, footer } = APPCONFIG
    return (
      <div className='app-footer'>
        <div className='footer-content flex-align-justify'>
          <div className='max-width flex-align'>
            <div className='flex-one flex-column-justify'>
              <div>
                <div className='footer-link'>{footer.link[lang]}</div>
              </div>
              <div className='footer-company flex-align'>
                {
                  footer.company.map((item, index) => {
                    return (
                      <a className='company-link' key={index} href={item.link} target='_blank' rel='noreferrer'>
                        <img className='company-image' key={index} alt={item.name[lang]} title={item.name[lang]} src={item.logo}></img>
                      </a>
                    )
                  })
                }
              </div>
            </div>
            <div className='footer-contact'>
              <div className='contact-item user-select'>{contact.location.label[lang]}{lang === 'cn' ? '：' : ':'}{contact.location.value[lang]}</div>
              <div className='contact-item user-select'>{contact.phone.label[lang]}{lang === 'cn' ? '：' : ':'}{contact.phone.value[lang]}</div>
              <div className='contact-item user-select'>{contact.fax.label[lang]}{lang === 'cn' ? '：' : ':'}{contact.fax.value[lang]}</div>
              <div className='contact-item user-select'>{contact.postal.label[lang]}{lang === 'cn' ? '：' : ':'}{contact.postal.value[lang]}</div>
            </div>
            {/* <div className='footer-qrcode background-image'></div> */}
          </div>
        </div>
        <div className='footer-copyright flex-column-align-justify'>
          <div>{footer.copyright}</div>
          <div className='flex-align'>
            {/* <a
              className='flex-align'
              href={`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${33010002000070}`}
              target='_blank' rel='noreferrer'
            >
              <img src={IconBenan} alt=''></img>
              <span>浙公网安备33010002000070</span>
            </a> */}
            <a href='https://beian.miit.gov.cn' target='_blank' rel='noreferrer'>沪ICP备18045957号-1</a>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(AppFooter)
